module.exports = __webpack_public_path__ + "assets/img/4.90744299.gif";